import React, { useCallback, useState } from "react";

import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { useSelector } from "react-redux";
import { RootState } from "../../Store";
//import { colourOptions } from "./data";

//const CustomClearText = () => "clear all";
// const ClearIndicator = (props) => {
//   const {
//     children = <CustomClearText />,
//     getStyles,
//     innerProps: { ref, ...restInnerProps },
//   } = props;
//   return (
//     <div
//       {...restInnerProps}
//       ref={ref}
//       style={getStyles("clearIndicator", props)}
//     >
//       <div style={{ padding: "0px 5px" }}>{children}</div>
//     </div>
//   );
// };

const ClearIndicatorStyles = (base, state) => ({
  ...base,
  cursor: "pointer",
  color: state.isFocused ? "blue" : "black",
});

export default function SelectComponent(props) {
  const {
    create = true,
    options = [],
    multiple = false,
    onValueSelect = () => "",
    name = "",
    selected,
    selectRef = "",
    label = "",
  } = props;

  const profile = useSelector((state: RootState) => state.auth.profile);

  const formatOptionList = useCallback(
    (res, selectedData = [], isMulti = false) => {
      if (res.length > 0) {
        let optionArray = [];
        let selectedOptions = isMulti ? [] : {};
        res.forEach((obj, i) => {
          if (selectedData.includes(String(obj.value))) {
            if (!isMulti) {
              selectedOptions = { value: obj?.value, label: obj?.label };
            } else {
              selectedOptions.push({ value: obj?.value, label: obj?.label });
            }
          }
        });
        return selectedOptions;
      }
    },
    []
  );

  const filterOptionValue = useCallback(() => {
    if (profile && name !== "" && profile[name] !== undefined) {
      let skillsArray = String(profile[name]).split(",");
      return formatOptionList(options, skillsArray, multiple);
    } else {
      return multiple ? [] : {};
    }
  }, [formatOptionList, profile, options, multiple]);

  if (options.length < 1) {
    return null;
  }

  return (
    <>
      {create && (
        <CreatableSelect
          ref={selectRef}
          //closeMenuOnSelect={false}
          //components={{ ClearIndicator }}
          defaultValue={filterOptionValue()}
          //value={selected ? selected : null}
          styles={{ clearIndicator: ClearIndicatorStyles }}
          defaultValue={selected}
          isMulti={multiple}
          isClearable={true}
          options={options}
          onChange={(value) => onValueSelect(value, name)}
        />
      )}
      {!create && (
        <Select
          ref={selectRef}
          //closeMenuOnSelect={false}
          //components={{ ClearIndicator }}
          //defaultValue={filterOptionValue()}
          //value={selected ? selected : null}
          styles={{ clearIndicator: ClearIndicatorStyles }}
          defaultValue={selected}
          isMulti={multiple}
          isClearable={true}
          options={options}
          onChange={(value) => onValueSelect(value, name)}
          //placeholder={"ASD"}
        />
      )}
    </>
  );
}
